import { render, staticRenderFns } from "./SubJobStageDetail.vue?vue&type=template&id=78ca2acc"
import script from "./SubJobStageDetail.vue?vue&type=script&lang=js"
export * from "./SubJobStageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78ca2acc')) {
      api.createRecord('78ca2acc', component.options)
    } else {
      api.reload('78ca2acc', component.options)
    }
    module.hot.accept("./SubJobStageDetail.vue?vue&type=template&id=78ca2acc", function () {
      api.rerender('78ca2acc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/subjobstage/SubJobStageDetail.vue"
export default component.exports